import { WorkspacesTableRow } from './WorkspacesTableRow.jsx';

const WorkspacesTable = ({ workspaces = [], headers = {}, onSelect }) => {
  const h = {
    name: headers.name ?? 'Name',
    owner: headers.owner ?? 'Owner',
    status: headers.status ?? 'Status',
    updated: headers.updated ?? 'Updated',
    members: headers.members ?? 'Members',
  };

  return (
    <div className="overflow-hidden rounded-xl border border-edge">
      <table className="w-full text-left">
        <thead>
          <tr className="border-b border-edge bg-surface-muted">
            <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-content-muted">
              {h.name}
            </th>
            <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-content-muted">
              {h.owner}
            </th>
            <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-content-muted">
              {h.status}
            </th>
            <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-content-muted">
              {h.updated}
            </th>
            <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-content-muted">
              {h.members}
            </th>
            <th className="w-10 px-4 py-2.5" />
          </tr>
        </thead>
        <tbody className="bg-surface">
          {workspaces.map((workspace) => (
            <WorkspacesTableRow key={workspace.id} workspace={workspace} onSelect={onSelect} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WorkspacesTable;
